import React from 'react';
import { BaseButton, type BaseButtonProps } from './BaseButton';

export type ButtonProps = {
  /** Visual style */
  variant?: BaseButtonProps['variant'];
  /** Visual size */
  size?: BaseButtonProps['size'];
  /** Color palette */
  color?: BaseButtonProps['color'];
  /** Disabled state */
  disabled?: BaseButtonProps['disabled'];
  /** Button type attribute */
  type?: BaseButtonProps['type'];
  /** Optional start icon */
  startIcon?: BaseButtonProps['startIcon'];
  /** Optional end icon */
  endIcon?: BaseButtonProps['endIcon'];
  /** DOM id */
  id?: BaseButtonProps['id'];
  /** Click handler */
  onClick?: BaseButtonProps['onClick'];
  /** Button label/content */
  children: BaseButtonProps['children'];
  /** Text transform */
  textTransform?: BaseButtonProps['textTransform'];
  /** Min width */
  minWidth?: BaseButtonProps['minWidth'];
  /** Full width */
  fullWidth?: BaseButtonProps['fullWidth'];
  /**
   * Marks the rendered button so an inline-edit input's blur handler keeps editing
   * alive when focus lands here (see {@link InlineTextField}).
   */
  'data-keep-inline-edit'?: BaseButtonProps['data-keep-inline-edit'];
};

export const Button: React.FC<ButtonProps> = (props) => (
  <BaseButton {...props} />
);
